import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BusinessProvider } from './lib/business';
import { ImagesProvider } from './lib/images';
import { AuthProvider } from './lib/auth';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <BusinessProvider>
          <ImagesProvider>
            <App />
          </ImagesProvider>
        </BusinessProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
